import {
  DefinitionsLimitBanner as DefinitionsLimitBannerShared,
  isDefinitionsLimitReached,
} from '@github-ui/custom-properties-core/components/DefinitionsLimitBanner'
import {PropertyPageHeader as PropertyPageHeaderShared} from '@github-ui/custom-properties-core/components/PropertyPageHeader'
import type {OrgEditPermissions} from '@github-ui/custom-properties-types'
import {Link} from '@github-ui/react-router'
import {Button} from '@primer/react'

import {useNewPropertyPath} from '../hooks/use-property-details-paths'

export function DefinitionsPageHeader({
  ownDefinitionsCount,
  permissions,
}: {
  ownDefinitionsCount: number
  permissions: OrgEditPermissions
}) {
  const newPropertyPath = useNewPropertyPath()

  // Currently, only at the org level, there can be a mix of org props and business props
  const definitionLimitReached = isDefinitionsLimitReached(ownDefinitionsCount)

  const canCreateProperty = !definitionLimitReached && (permissions === 'all' || permissions === 'definitions')

  return (
    <>
      <PropertyPageHeaderShared
        title="Repository custom properties"
        subtitle="Add metadata to your repositories, such as compliance frameworks, data sensitivity, or project details."
        actions={
          canCreateProperty && (
            <Button as={Link} to={newPropertyPath} variant="primary" data-testid="add-definition-button">
              New property
            </Button>
          )
        }
      />
      {definitionLimitReached && (
        <div className="mb-2">
          <DefinitionsLimitBannerShared />
        </div>
      )}
    </>
  )
}
